import {
  User,
  AuthUser,
  Subscription,
} from "./../store/Authentication/auth.models";
import { Injectable } from "@angular/core";

import { HttpClient, HttpHeaders } from "@angular/common/http";
import { catchError, map } from "rxjs/operators";
import { BehaviorSubject, Observable, of, throwError } from "rxjs";

import { getFirebaseBackend } from "../../../authUtils";
import { GlobalComponent } from "../../../global-component";
import { Router } from "@angular/router";
import {
  adminMenuItems,
  applicantAdminMenuItems,
  collegeAdminMenuItems,
  facultyAdminMenuItems,
  hrAdminMenuItems,
  MenuItem,
  studentMenuItems,
} from "../common/sidebar/sidebar-menu";
import { ToastrService } from "ngx-toastr";
import { SweetAlertService } from "./sweet-alert.service";

import { switchMap } from "rxjs/operators";
import { StudentService } from "../college-admin-dashbaord/student-holds/student.service";
import { RestrictionService } from "../student-dashboard/account-holds/restriction.service";
import { FeatureService } from "./feature.service";

const AUTH_API = GlobalComponent.AUTH_API;

const httpOptions = {
  headers: new HttpHeaders({ "Content-Type": "application/json" }),
};

export interface CollegeInfo {
  collegeName: string;
  pricingPlan: string;
  accreditationBody: string;
  registrationNumber: string;
  collegeEmail: string;
  phoneNumber: string;
  streetAddress: string;
  city: string;
  state: string;
}

export interface ContactInfo {
  primaryContactName: string;
  roleTitle: string;
  email: string;
  phoneNumber: string;
  billingEmail?: string;
}

export interface Branding {
  logoUrl?: string;
  portalDisplayName: string;
  primaryBrandColor: string;
  secondaryBrandColor: string;
}

export interface Documents {
  accreditationCertificate?: File;
  registrationCertificate?: File;
  otherDocuments: File[];
}

export interface CollegeProfile {
  collegeInfo: CollegeInfo;
  contactInfo: ContactInfo;
  branding: Branding;
  documents: Documents;
}

@Injectable({ providedIn: "root" })
export class AuthenticationService {
  user!: any;
  currentUserValue: any;

  currentUserSubject = new BehaviorSubject<AuthUser | null>(null);
  loggedInUser$ = this.currentUserSubject.asObservable();

  public hasActiveHolds$ = new BehaviorSubject<boolean>(false);
  public holdCount$ = new BehaviorSubject<number>(0);

  constructor(
    private http: HttpClient,
    private router: Router,
    public toastrService: ToastrService,
    private sweetAlert: SweetAlertService,
    private studentService: StudentService,
    private featureService: FeatureService,
    private restrictionService: RestrictionService,
  ) {
    if (
      typeof window !== "undefined" &&
      typeof sessionStorage !== "undefined"
    ) {
      const stored = sessionStorage.getItem("currentUser");
      if (stored) {
        this.currentUserSubject.next(JSON.parse(stored));
      }
    }
  }

  //
  /**
   * Returns the current user
   */
  public currentUser(): any {
    return this.currentUserSubject.value;
  }

  public updateCurrentUser(updatedUser: AuthUser): void {
    // update BehaviorSubject
    this.currentUserSubject.next(updatedUser);

    // persist to sessionStorage
    sessionStorage.setItem("currentUser", JSON.stringify(updatedUser));
  }
  dismissTrialEndingSoon() {
    const user = this.currentUser();

    if (!user) return;

    const updatedUser: AuthUser = {
      ...user,
      subscription: {
        ...user.subscription,
        alerts: {
          ...user.subscription.alerts,
          showTrialEndingSoon: false,
        },
      },
    };

    this.updateCurrentUser(updatedUser);
  }

  updateSubscription(newSubscription: Subscription) {
    const user = this.currentUser();

    if (!user) return;

    const updatedUser: AuthUser = {
      ...user,
      subscription: newSubscription,
    };

    this.updateCurrentUser(updatedUser);
  }

  /**
   * Returns the current user's ID
   */
  getCurrentUserId(): number | null {
    const currentUser = this.currentUser();
    return currentUser ? currentUser.id : null;
  }
  //a method to get tenant id from current user

  getTenantId(): number | null {
    const currentUser = this.currentUser();
    return currentUser ? currentUser.tenantId : null;
  }
  getTenantInfo(): Observable<any> {
    return this.http.get(`/tenants/get/branding`, {});
  }

  /**
   * Performs the register
   * @param email email
   * @param password password
   */
  register(userData: any, isApplicant?: boolean) {
    console.log("calling  register from auth service", userData);
    const requestUrl = isApplicant ? '/auth/applicant' : '/auth/register'
    userData;
    return this.http.post(requestUrl, userData, httpOptions).pipe(
      map((response: any) => {
        console.log("register from authservice", response);
        const user = response;
        return user;
      }),
      catchError((error: any) => {
        const errorMessage = "Login failed";
        console.log(error);
        return throwError(error.errorMessage);
      }),
    );
  }

  completeProfile() {
    return this.http.post(`/auth/complete-profile`, {}).pipe(
      map((response: any) => {
        console.log("complete profile from authservice", response);
        const user = response;
        return user;
      }),
      catchError((error: any) => {
        const errorMessage = "Login failed";
        console.log(error);
        return throwError(error.errorMessage);
      }),
    );
  }

  verifyAccount(data: any) {
    return this.http.post(`/auth/verify`, data);
  }

  forgotPassword(data: any) {
    return this.http.post(`/auth/forgot-password`, data);
  }

  // resetPassword(data: any) {
  //   return this.http.post(`/auth/reset`, data);
  // }

  checkIfEmailExist(email: string): Observable<any> {
    return this.http.get(`/auth/validateemail/${email}`).pipe();
  }

  checkIfUsernameExist(username: string): Observable<any> {
    return this.http.get(`/auth/validateusername/${username}`).pipe();
  }
  checkIfPhoneExist(phoneNumber: string): Observable<any> {
    return this.http.get(`/auth/validatephonenumber/${phoneNumber}`).pipe();
  }

  /**
   * Performs the auth
   * @param usernameOrEmail email of user
   * @param password password of user
   */

  login(usernameOrEmail: string, password: string) {
    // console.log(usernameOrEmail, password);
    console.log("authservice called");

    return this.http
      .post(
        "/authentication/auth",
        {
          usernameOrEmail,
          password,
        },
        httpOptions,
      )
      .pipe(
        switchMap((user: any) => {
          console.log("Login response:", JSON.stringify(user));

          if (user && user.base64EncodedAuthenticationKey) {
            sessionStorage.setItem("toast", "true");

            if (user && user?.subscription?.plan) {
              this.featureService.setPlan(user.subscription?.plan);
            }

            sessionStorage.setItem(
              "auth-token",
              user.base64EncodedAuthenticationKey,
            );

            // Check if this is a student (userType === 1)
            if (user?.userType === 1) {
              // Get student ID from the user object
              const studentId = user.userId?.toString() || user.username;

              console.log(
                "Student logged in, fetching holds for ID:",
                studentId,
              );

              // FETCH HOLDS HERE - DURING LOGIN
              return this.studentService.getHoldsByStudentId(studentId).pipe(
                map((holds) => {
                  console.log("Holds fetched from API:", holds);

                  // Filter active holds
                  const activeHolds = holds.filter((h) => h.isActive == true);

                  // Attach holds to user object
                  user.holds = activeHolds;
                  user.hasHolds = activeHolds.length > 0;
                  user.holdCount = activeHolds.length;
                  user.holdTypes = activeHolds.map((h) => h.type);

                  console.log(
                    `Student has ${activeHolds.length} active holds:`,
                    activeHolds.map((h) => h.type),
                  );

                  // Store holds in session with timestamp
                  sessionStorage.setItem(
                    "studentHolds",
                    JSON.stringify(activeHolds),
                  );

                  // Store metadata for debugging
                  sessionStorage.setItem(
                    "holdsMetadata",
                    JSON.stringify({
                      lastUpdated: new Date().toISOString(),
                      count: activeHolds.length,
                      types: activeHolds.map((h) => h.type),
                    }),
                  );

                  // Update restriction service with hold types (strings, not objects)
                  if (activeHolds.length > 0) {
                    const holdTypes = activeHolds.map((h) => h.type);
                    this.restrictionService.updateRestrictions(holdTypes);
                    console.log(
                      "Restriction service updated with hold types:",
                      holdTypes,
                    );

                    // Update observables
                    this.hasActiveHolds$.next(true);
                    this.holdCount$.next(activeHolds.length);
                  } else {
                    this.restrictionService.clearRestrictions();
                    this.hasActiveHolds$.next(false);
                    this.holdCount$.next(0);
                    console.log("No active holds - restrictions cleared");
                  }

                  // Store user in session with enhanced data
                  const userWithHolds = {
                    ...user,
                    holds: activeHolds,
                    hasHolds: activeHolds.length > 0,
                    holdCount: activeHolds.length,
                    holdTypes: activeHolds.map((h) => h.type),
                    loginTime: new Date().toISOString(),
                  };

                  sessionStorage.setItem(
                    "currentUser",
                    JSON.stringify(userWithHolds),
                  );
                  this.currentUserSubject.next(userWithHolds);

                  // Log summary for debugging
                  console.log("Login complete:", {
                    userId: studentId,
                    hasHolds: activeHolds.length > 0,
                    holdCount: activeHolds.length,
                    holdTypes: activeHolds.map((h) => h.type),
                  });

                  return userWithHolds;
                }),
              );
            }

            // Not a student, just store user
            console.log(
              "Non-student user logged in, userType:",
              user?.userType,
            );
            sessionStorage.setItem("currentUser", JSON.stringify(user));
            this.currentUserSubject.next(user);

            // Update observables
            this.hasActiveHolds$.next(false);
            this.holdCount$.next(0);
          }

          return of(user);
        }),
        catchError((error: any) => {
          console.error("Login error:", error);
          const errorMessage =
            error.error?.message ||
            "Login failed. Please check your credentials.";

          // Clear any existing session data on error
          sessionStorage.removeItem("studentHolds");
          sessionStorage.removeItem("holdsMetadata");
          sessionStorage.removeItem("currentUser");
          sessionStorage.removeItem("auth-token");

          this.hasActiveHolds$.next(false);
          this.holdCount$.next(0);

          return throwError(() => new Error(errorMessage));
        }),
      );
  }

  /**
   * Refresh student holds - call after resolving a hold
   */
  refreshStudentHolds(): Observable<any[]> {
    const user = this.currentUser();

    // Only students can refresh holds
    if (user?.userType !== 1) {
      console.log("Non-student user attempted to refresh holds");
      return of([]);
    }

    const studentId = user.userId?.toString() || user.username;

    console.log("Refreshing holds for student:", studentId);

    return this.studentService.getHoldsByStudentId(studentId).pipe(
      map((holds) => {
        // Filter active holds
        const activeHolds = holds.filter((h) => h.isActive == true);

        console.log("Refreshed holds from API:", {
          total: holds.length,
          active: activeHolds.length,
          types: activeHolds.map((h) => h.type),
        });

        // Update session storage with new holds
        sessionStorage.setItem("studentHolds", JSON.stringify(activeHolds));

        // Store metadata for debugging
        sessionStorage.setItem(
          "holdsMetadata",
          JSON.stringify({
            lastRefreshed: new Date().toISOString(),
            count: activeHolds.length,
            types: activeHolds.map((h) => h.type),
            fromCache: false,
          }),
        );

        // Update user object with new hold data
        const updatedUser = {
          ...user,
          holds: activeHolds,
          hasHolds: activeHolds.length > 0,
          holdCount: activeHolds.length,
          holdTypes: activeHolds.map((h) => h.type),
          lastHoldRefresh: new Date().toISOString(),
        };

        // Update session and subject
        sessionStorage.setItem("currentUser", JSON.stringify(updatedUser));
        this.currentUserSubject.next(updatedUser);

        // Update observables
        this.hasActiveHolds$.next(activeHolds.length > 0);
        this.holdCount$.next(activeHolds.length);

        // Update restriction service with hold types (strings, not objects)
        if (activeHolds.length > 0) {
          const holdTypes = activeHolds.map((h) => h.type);
          this.restrictionService.updateRestrictions(holdTypes);
          console.log(
            "Restriction service updated with hold types:",
            holdTypes,
          );
        } else {
          this.restrictionService.clearRestrictions();
          console.log("No active holds - restrictions cleared");
        }

        // Compare with previous state to detect changes
        const previousHolds = user.holds || [];
        const previousTypes = previousHolds
          .map((h: any) => h.type)
          .sort()
          .join(",");
        const newTypes = activeHolds
          .map((h) => h.type)
          .sort()
          .join(",");

        if (previousTypes !== newTypes) {
          console.log("Hold state changed:", {
            before: previousHolds.map((h: any) => h.type),
            after: activeHolds.map((h) => h.type),
          });
        }

        return activeHolds;
      }),
      catchError((error) => {
        console.error("Error refreshing holds:", error);

        // Log error to session for debugging
        sessionStorage.setItem(
          "holdRefreshError",
          JSON.stringify({
            timestamp: new Date().toISOString(),
            error: error.message,
            studentId: studentId,
          }),
        );

        return throwError(() => new Error("Failed to refresh holds"));
      }),
    );
  }

  /**
   * Force refresh holds and emit event for UI updates
   */
  forceRefreshHolds(): Observable<any[]> {
    return this.refreshStudentHolds().pipe(
      map((holds) => {
        // Dispatch custom event for UI updates
        window.dispatchEvent(
          new CustomEvent("holdsUpdated", {
            detail: { holds, timestamp: new Date().toISOString() },
          }),
        );
        return holds;
      }),
    );
  }

  /**
   * Check if holds have changed since last refresh
   */
  haveHoldsChanged(): Observable<boolean> {
    const user = this.currentUser();
    if (user?.userType !== 1) {
      return of(false);
    }

    const studentId = user.userId?.toString() || user.username;

    return this.studentService.getHoldsByStudentId(studentId).pipe(
      map((holds) => {
        const activeHolds = holds.filter((h) => h.isActive == true);
        const currentHolds = user.holds || [];

        // Compare hold types
        const currentTypes = currentHolds
          .map((h: any) => h.type)
          .sort()
          .join(",");
        const newTypes = activeHolds
          .map((h) => h.type)
          .sort()
          .join(",");

        const changed = currentTypes !== newTypes;

        if (changed) {
          console.log("Hold change detected:", {
            from: currentHolds.map((h: any) => h.type),
            to: activeHolds.map((h) => h.type),
          });
        }

        return changed;
      }),
      catchError(() => of(false)),
    );
  }

  /**
   * Clear hold refresh errors from session
   */
  clearHoldErrors(): void {
    sessionStorage.removeItem("holdRefreshError");
    console.log("Hold errors cleared from session");
  }

  /**
   * Check if user has active holds (synchronous)
   */
  hasActiveHolds(): boolean {
    const user = this.currentUser();
    return user?.hasHolds === true;
  }

  /**
   * Get hold count (synchronous)
   */
  getHoldCount(): number {
    const user = this.currentUser();
    return user?.holdCount || 0;
  }

  /**
   * Get current student's holds from session
   */
  getCurrentStudentHolds(): Observable<any[]> {
    const user = this.currentUser();
    if (user?.userType !== 1) {
      return of([]);
    }

    const holdsJson = sessionStorage.getItem("studentHolds");
    if (holdsJson) {
      return of(JSON.parse(holdsJson));
    }

    return of([]);
  }

  enableTwoFactor(payload: { enabled: boolean }) {
    return this.http.put("/profile/two-factor", payload);
  }

  sendTwoFactorCode() {
    return this.http.post("/profile/two-factor/send-code", {});
  }

  verifyTwoFactorCode(code: any) {
    return this.http.post("/profile/two-factor/verify", code);
  }
  updateTwoFactorStatus(value: boolean) {
    const currentUser = this.currentUserSubject.value;

    if (!currentUser) return;

    const updatedUser = {
      ...currentUser,
      twoFactorAuthenticationRequired: value,
    };

    // Update observable
    this.currentUserSubject.next(updatedUser);

    // Update session storage
    sessionStorage.setItem("currentUser", JSON.stringify(updatedUser));
  }

  logout() {
    sessionStorage.removeItem("currentUser");
    sessionStorage.removeItem("auth-token");
    sessionStorage.removeItem("studentHolds");
    sessionStorage.removeItem("activeRestrictions");

    // Clear restrictions
    this.restrictionService.clearRestrictions();

    this.currentUserSubject.next(null!);
    this.router.navigate(["/authentication"]);
    return of(undefined).pipe();
  }

  /**
   * Reset password
   * @param email email
   */
  resetPassword(email: string) {
    return getFirebaseBackend()!
      .forgetPassword(email)
      .then((response: any) => {
        const message = response.data;
        return message;
      });
  }

  /**
   * gets user permissions of logged in user in local storage
   */
  getUserPermissions() {
    let user = JSON.parse(sessionStorage.getItem("currentUser")!);
    if (user) {
      console.log(JSON.stringify(user));
      const userPermissions: any[] = user?.permissions;
      console.log("userPermissions>>> @getUserPermissions", userPermissions);
      return userPermissions;
    }
    return [];
  }

  /**
   * Utility function to check if  a user has given permission
   * @param permission
   */
  hasPermission(permission: string) {
    // this.log.info('Check if user has Permission ');
    console.log("permission>>>>>>>>>>", permission);
    // permission = permission;
    // FYI: getting all permissions from localstorage, because if scope changes permissions array will become undefined
    const permissionList = this.getUserPermissions();
    // this.log.info('-- Permissions List --');
    // this.log.info(permissionList);
    // If user is a Super user return true
    if (permissionList && permissionList.indexOf("ALL_FUNCTIONS") > -1) {
      return true;
    } else if (permissionList && permission && permission !== "") {
      // If user have all read permission return true
      if (
        permission.substring(0, 5) === "READ_" &&
        permissionList.indexOf("ALL_FUNCTIONS_READ") > -1
      ) {
        return true;
      } else if (permissionList.indexOf(permission) > -1) {
        // check for the permission if user doesn't have any special permissions
        return true;
      } else {
        // return false if user doesn't have permission
        return false;
      }
    } else {
      // return false if no value assigned to has-permission directive
      return false;
    }
  }

  redirectAfterLogin(user: any) {
    const dashboardByType: Record<number, string> = {
      0: "/admin-dashboard/welcome",
      1: "/student-dashboard/welcome",
      2: "/admin-dashboard/welcome",
      3: "/college-admin-dashboard/welcome",
      4: "/faculty-admin-dashboard/welcome",
      5: "/college-admin-dashboard/welcome",
      6: "/college-admin-dashboard/welcome",
      7: "/college-admin-dashboard/welcome",
      8: "/college-admin-dashboard/welcome",
      9: "/hr-admin-dashboard/welcome",
      10: "/applicant-admin-dashboard/welcome",
    };

    let target = dashboardByType[user?.userType] || "/authentication";

    // Special handling for students (userType 1)
    if (user?.userType === 1) {
      // Check if student has holds
      if (user.hasHolds) {
        // Show warning message
        this.toastrService.warning(
          `You have ${user.holds.length} active hold(s). Some features may be restricted.`,
          "Account Holds",
          { timeOut: 8000 },
        );

        // Redirect to account holds page first
        target = "/student-dashboard/account-holds";
      } else {
        // No holds, go to dashboard
        this.toastrService.success(
          "Login successful! No active holds.",
          "Welcome",
        );
        target = "/student-dashboard/welcome";
      }
    }

    // College admin handling (existing)
    const collegeUserTypes = [3, 4, 5, 6, 7, 8];
    if (collegeUserTypes.includes(user?.userType)) {
      if (user.isTenant === false || user.isTenant === "false") {
        target = "/authentication/complete-profile";
      }
    }

    console.log("Redirecting to:", target);
    this.router.navigateByUrl(target);
  }

  getMenuForCurrentUser(): MenuItem[] {
    const user = this.currentUserSubject.value;
    if (!user) return [];

    switch (user.userType) {
      case 1:
        return this.filterMenuByPermissions(studentMenuItems, user.permissions);

      case 8:
      case 3:
      case 5:
      case 6:
      case 7:
        return this.filterMenuByPermissions(
          collegeAdminMenuItems,
          user.permissions,
        );
      case 4:
        return this.filterMenuByPermissions(
          facultyAdminMenuItems,
          user.permissions,
        );

      case 9:
        return this.filterMenuByPermissions(
          hrAdminMenuItems,
          user.permissions,
        );

      case 10:
        return this.filterMenuByPermissions(
          applicantAdminMenuItems,
          user.permissions,
        );

      default:
        return this.filterMenuByPermissions(adminMenuItems, user.permissions);
    }
  }

  private filterMenuByPermissions(
    menu: MenuItem[],
    userPermissions: string[],
  ): MenuItem[] {
    return menu
      .filter((item) => this.hasAccess(item.permissions, userPermissions))
      .map((item) => ({
        ...item,
        subItems: item.subItems
          ? this.filterMenuByPermissions(item.subItems, userPermissions)
          : undefined,
      }));
  }

  private hasAccess(
    required: string[] | undefined,
    userPerms: string[],
  ): boolean {
    if (!required || required.length === 0) return true;
    if (userPerms.includes("ALL_FUNCTIONS")) return true;

    const isReadRequired = required.some((p) => p.startsWith("READ_"));
    if (isReadRequired && userPerms.includes("ALL_FUNCTIONS_READ")) return true;

    return required.some((p) => userPerms.includes(p));
  }

  // -------- COLLEGE INFO --------
  updateCollege(data: any): Observable<any> {
    return this.http.put(`/tenants/update/college`, data);
  }

  getCollege(id: number): Observable<any> {
    return this.http.get(`/tenants/get/college/${id}`);
  }

  // -------- CONTACT INFO --------
  updateContact(data: any): Observable<any> {
    return this.http.put(`/tenants/update/contact`, data);
  }

  getContact(id: number): Observable<any> {
    return this.http.get(`/tenants/get/contact/${id}`);
  }

  updateBranding(formData: FormData): Observable<any> {
    return this.http.put(`/tenants/update/branding`, formData);
  }

  getBranding(id: number): Observable<any> {
    return this.http.get(`/tenants/get/branding/${id}`);
  }

  // -------- DOCUMENTS (multipart) --------
  updateDocuments(formData: FormData): Observable<any> {
    return this.http.put(`/tenants/update/documents`, formData);
  }

  getDocuments(id: number): Observable<any> {
    return this.http.get(`/tenants/get/documents/${id}`);
  }

  // -------- TERMS --------
  updateTerms(data: any): Observable<any> {
    return this.http.put(`/tenants/update/terms`, data);
  }

  getTerms(id: number): Observable<any> {
    return this.http.get(`/tenants/get/terms/${id}`);
  }

  getDocumentAsBlob(url: string): Observable<Blob> {
    // Include authentication headers/tokens if needed
    const headers = this.getAuthHeaders();
    return this.http.get(url, {
      headers,
      responseType: "blob",
    });
  }

  getDocumentAsArrayBuffer(url: string): Observable<ArrayBuffer> {
    const headers = this.getAuthHeaders();
    return this.http.get(url, {
      headers,
      responseType: "arraybuffer",
    });
  }

  private getAuthHeaders(): HttpHeaders {
    // Get your auth token from wherever it's stored
    const token =
      localStorage.getItem("auth_token") ||
      sessionStorage.getItem("auth_token");

    if (token) {
      return new HttpHeaders({
        Authorization: `Bearer ${token}`,
        Accept: "application/octet-stream",
      });
    }

    // If you have other auth methods, add them here
    return new HttpHeaders({
      Accept: "application/octet-stream",
    });
  }

  // Create a blob URL from blob data
  createBlobUrl(blob: Blob): string {
    return URL.createObjectURL(blob);
  }

  // Clean up blob URL
  revokeBlobUrl(url: string): void {
    URL.revokeObjectURL(url);
  }
}
